import { prepareSearchCriteria } from "../../../../../Infrastructure/Services/ApiUtility";
import { Reactions } from "./ReactionsListModal.types";
import * as client from "../../../../../Infrastructure/ClientConsumer";

const routes = {
    GET_REACTIONS_FOR_COMMENT: "/comments/:commentId/reactions",
    GET_REACTIONS_OF_TYPE_FOR_COMMENT:
        "/comments/:commentId/reactions/:type/load-more",
    GET_REACTIONS_FOR_POST: "/posts/:postId/reactions",
    GET_REACTIONS_OF_TYPE_FOR_POST: "/posts/:postId/reactions/:type/load-more",
};

export async function getPostReactions(
    postId: string,
    limit?: number,
): Promise<Reactions[]> {
    return client
        .getData(
            routes.GET_REACTIONS_FOR_POST.replace(":postId", postId) +
                prepareSearchCriteria({ limit }),
        )
        .then((res) => {
            return res.data.postReactions;
        });
}

export async function getPostSpecificTypeReactions(
    postId: string,
    reactionType: string,
    cursor: number,
    limit: number,
): Promise<Reactions> {
    return client
        .getData(
            routes.GET_REACTIONS_OF_TYPE_FOR_POST.replace(
                ":postId",
                postId,
            ).replace(":type", reactionType) +
                prepareSearchCriteria({ cursor, limit }),
        )
        .then((res) => {
            return res.data.postReactions[0];
        });
}

export async function getCommentReactions(
    postId: string,
    limit?: number,
): Promise<Reactions[]> {
    return client
        .getData(
            routes.GET_REACTIONS_FOR_COMMENT.replace(":postId", postId) +
                prepareSearchCriteria({ limit }),
        )
        .then((res) => {
            return res.data.postReactions;
        });
}

export async function getCommentSpecificTypeReactions(
    postId: string,
    reactionType: string,
    cursor: number,
    limit: number,
): Promise<Reactions> {
    return client
        .getData(
            routes.GET_REACTIONS_OF_TYPE_FOR_COMMENT.replace(
                ":postId",
                postId,
            ).replace(":type", reactionType) +
                prepareSearchCriteria({ cursor, limit }),
        )
        .then((res) => {
            return res.data.postReactions[0];
        });
}
